import React, { Component } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Signup from "./Signup";
import Dalkan from "./Dalkan";
import VerifyDalkan from "./VerifyDalkan";

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route path="/signup" component={Signup} />
          <Route path="/dalkan" component={Dalkan} />
          <Route path="/verify-dalkan" component={VerifyDalkan} />
        </Switch>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js